import React from 'react';
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import PageList from "../../../components/Constant/List/List";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import HeroImage from "../../../assets/images/area/ready-made-image.png";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Ready Made',
        link: '/ready-made',
    },
]

function ReadyMade () {

    const pageTable = [
        {
            paragraph: 'Pre-registered company (0–3 years old)',
        },
        {
            paragraph: 'Verified corporate bank account (EMI or traditional bank) ',
        },
        {
            paragraph: 'Official company documents (Certificate of Incorporation, M&AA, Resolution)',
        },
        {
            paragraph: 'Share transfer documents (notarized and apostilled if required) ',
        },
        {
            paragraph: 'Online banking access and debit card (where applicable)',
        },
        {
            paragraph: 'KYC dossier for smooth onboarding with service providers',
        },
        
    ];
    
    const table1 = [
        {
            title: 'UAE',
            paragraph: '(Dubai, RAK, Ajman Freezone) – Account with local or EMI banks',
        },
        
        {
            title: 'Cyprus',
            paragraph: 'Active IBAN and SEPA-enabled accounts ',
        },
        
        {
            title: 'UK',
            paragraph: 'Companies with accounts at Revolut, Wise, or traditional banks ',
        },
        
        {
            title: 'Malta',
            paragraph: 'EU-accessible companies with fintech-licensed accounts',
        },
        
        {
            title: 'Mauritius',
            paragraph: 'Ideal for Africa/MENA trade, with local bank setups ',
        },
        
        {
            title: 'Offshore',
            paragraph: 'Mwali, anjouan-offshore-offshore-company-formation, Seychelles, Belize – Accounts with fintech EMIsAccounts with fintech EMIsAccounts with fintech EMIsAccounts with fintech EMIsAccounts with fintech EMIsAccounts with fintech EMIsAccounts with fintech EMIs',
        },
    ];
    
    const table2 = [
        {
            paragraph: 'Urgent operational start (contracts, invoicing, trading',
        },
        {
            paragraph: 'High-risk business activity (crypto, forex, gaming)',
        },
        {
            paragraph: 'Confidential expansion via secondary entity ',
        },
        {
            paragraph: 'Cross-border settlements with access to multi-currency accounts',
        },
        {
            paragraph: 'Alternative for clients who face local banking rejections',
        }
    ];

    const table3 = [
        {
            paragraph: 'Passport copy (certified)',
        },
        {
            paragraph: 'Proof of address (utility bill or bank statement)',
        },
        {
            paragraph: 'Source of funds ',
        },
        {
            paragraph: 'Brief business profile or intended use',
        },
        {
            paragraph: 'Signed share transfer agreement',
        }
    ];

    const table4 = [
        {
            title: 'Company Transfer',
            paragraph: '24–48 hours after KYC approval',
        },
        {
            title: 'Bank Account Activation',
            paragraph: '1–5 business days (varies by provider)',
        },
        {
            title: 'Document Dispatch',
            paragraph: 'Express courier or electronic delivery ',
        }
    ];

    const table5 = [
        {
            paragraph: 'Jurisdiction and company age',
        },
        {
            paragraph: 'Type of bank (EMI vs traditional)',
        },
        {
            paragraph: 'Risk category of business activity',
        },
        {
            paragraph: 'Additional services (nominee, legal opinion, VAT registration)',
        },
        
    ];
    return (
        <main className='main'>
            <section
                className='banking-license-section section'
            >
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>
                        Ready-Made Companies with Corporate Bank Accounts
                    </h1>
                    <div className='grid-container'>
                        <div className='flex-start'>

                            <PageList items={
                                [
                                    {
                                        paragraph: 'Ready-made company for sale in anjouan-offshore-offshore-company-formation start from 30,000 USD',
                                    },
                                    {
                                        paragraph: 'Ready-made company for sale in Mwali start from 20,000 USD',
                                    },
                                    {
                                        paragraph: 'Ready-made company for sale in Western Sahara start from 15,000 USD',
                                    },
                                ]
                            }/>


                            <p className='page-paragraph'>
                                At Offshore Advisory, we offer ready-made companies (also called shelf companies) in
                                reputable jurisdictions, each with a fully active corporate bank account — allowing
                                you to start operating immediately with minimal setup time.
                            </p>
                            
                            <h2 className='page-title'>
                                What’s Included?
                            </h2>
                            <p>Each ready-made package includes:</p>
                            <PageList items={pageTable}/>
                        </div>
                        <HeroRightImage src={HeroImage}/>
                    </div>


                    <div className='flex-start'>
                        <h2 className='page-title'>
                            Available Jurisdictions
                        </h2>
                        <p className='page-subtitle'>We maintain an active list of ready-made companies with accounts
                            in: </p>
                        <PageList items={table1}/>
                    </div>

                    <div className='flex-start'>
                        <h2 className='page-title'>
                            Use Cases
                        </h2>
                        <p className='page-subtitle'>We maintain an active list of ready-made companies with accounts
                            in: </p>
                        <PageList items={table2}/>
                    </div>

                    <div className='flex-start'>
                        <h2 className='page-title'>
                            Required Documents to Acquire
                        </h2>
                        <p className='page-subtitle'>To complete transfer and bank access activation, you’ll need: </p>
                        <PageList items={table3}/>
                    </div>
                    <div className='flex-start'>
                        <h2 className='page-title'>
                            Delivery Timeline
                        </h2>
                        <p className='page-subtitle'>To complete transfer and bank access activation, you’ll need: </p>
                        <PageList items={table4}/>
                    </div>
                    <div className='flex-start'>
                        <h2 className='page-title'>
                            Price Range
                        </h2>
                        <p className='page-subtitle'>Starting from $4,800 to $18,000 USD, depending on:</p>
                        <PageList items={table5}/>
                    </div>
                    <div className='flex-start'>
                        <h2 className='page-title'>
                            Confidentiality & Compliance
                        </h2>
                        <p className='page-subtitle'>All entities are verified, legally maintained, and in full compliance with local authorities.
                            We do not offer companies for illicit or unlicensed activities and conduct rigorous due
                            diligence prior to transfer. 
                        </p>
                    </div>
                    
                </div>


            </section>
        </main>
    )
        ;
}

export default ReadyMade;
